var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.page == 'login')?_c('Login',{on:{"change":_vm.changePage}}):(_vm.page == 'forgot-password')?_c('ForgotPassword',{on:{"change":_vm.changePage}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }